import axios from 'axios'
import {
	Content
} from '../entities/Content'
import {
	Product
} from '../entities/Product'
import {
	contentTemplate
} from '../template/ContentTemplate'
import {
	productTemplate
} from '../template/ProductTemplate'
import {
	asyncLoader
} from '../core/AsyncLoader'
class WebsiteService {
	baseUrl
	counter = 12
	_categories = {}

	get http () {
		return axios.create({
			baseURL: this.baseUrl,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		})
	}

	setBaseUrl (baseUrl) {
		this.baseUrl = baseUrl
		return this
	}

	setCounter (counter) {
		this.counter = counter
		return this
	}

	async getPosts ({
		offset
	}) {
		try {
			const {
				data
			} = await this.http.post('', this._getParams({
				offset
			}))
			asyncLoader.setFinished(data.finished)

			return data.news.map(this._createNews.bind(this))
		} catch (err) {
			console.error(err)
		}
	}

	_getParams ({
		offset
	}) {
		const params = new URLSearchParams()
		params.append('option', 'com_ajax')
		params.append('plugin', 'GetNews')
		params.append('format', 'json')
		params.append('counter', this.counter)
		params.append('offset', offset)
		return params
	}

	_createNews (element) {
		if (element.type === 'content') {
			const post = new Content()
			post.title = element.name
			post.link = element.link
			post.desc = element.desc
			post.img = element.img
			post.text = element.text
			post.template = contentTemplate
			return post
		} else {
			const product = new Product()
			product.title = element.name
			product.link = element.link
			product.img = element.img
			product.text = element.text
			product.technicalCard = element.technicalCard
			product.template = productTemplate
			return product
		}
	}
}

const websiteService = new WebsiteService()
export {
	WebsiteService,
	websiteService
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_news_loader/service/WebsiteService.js